import React, { useEffect, useState } from 'react';
import { EmployeeNodeModel } from '../../models';
import { EmployeesAPI } from '../../services/external/APIs';

export const useGetEmployees = (typeOfPerson: string) => {
    const [isLoadingTree, setIsLoadingTree] = useState(true);
    const [treeEmployees, setTreeEmployees] = useState<EmployeeNodeModel[]>([]);
    const [treeEmployeesCopy, setTreeEmployeesCopy] = useState<EmployeeNodeModel[]>(
        []
    );
    const [groupList, setGroupList] = useState<EmployeeNodeModel[]>([]);

    useEffect(() => {
        setIsLoadingTree(true);

        if (typeOfPerson === 'contractors') {
            EmployeesAPI.getContractors().then((response) => {
                setTreeEmployees(response);
                setTreeEmployeesCopy(response);
                setIsLoadingTree(false);

                setGroupList(
                    response.filter((emp) => emp.droppable || emp.parent === 0)
                );
            });
        } else if (typeOfPerson === 'all-employees') {
            EmployeesAPI.getEmployees(true).then((response) => {
                setTreeEmployees(response);
                setTreeEmployeesCopy(response);
                setIsLoadingTree(false);

                setGroupList(
                    response.filter((emp) => emp.droppable || emp.parent === 0)
                );
            });
        } else {
            EmployeesAPI.getEmployees(false).then((response) => {
                setTreeEmployees(response);
                setTreeEmployeesCopy(response);
                setIsLoadingTree(false);

                setGroupList(
                    response.filter((emp) => emp.droppable || emp.parent === 0)
                );
            });
        }
    }, [typeOfPerson]);

    return {
        isLoadingTree,
        treeEmployees,
        treeEmployeesCopy,
        groupList,
        setTreeEmployeesCopy,
        setTreeEmployees,
        setIsLoadingTree,
        setGroupList,
    };
};
